import React from 'react';

const Loading: React.FC = () => {
  return (
    <div className='flex items-center justify-center h-screen'>
      <div className='relative'>
        <div className='h-24 w-24 rounded-full border-t-8 border-b-8' style={{ borderColor: '#dddc01' }}></div>
        <div
          className='absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 animate-spin'
          style={{ borderColor: '#006087' }}
        ></div>
      </div>
    </div>
  );
};

export default Loading;

{
  /* <p className='ml-4 text-xl text-gray-700'>Loading...</p>; */
}
